import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { defineMessages, FormattedMessage } from 'react-intl';
import _ from 'lodash';

import * as actions from '../../../../state';
import { rememberBoard } from '../../../../events';

const messages = defineMessages({
  EDIT_BOARD: {
    id: 'EDIT_BOARD',
    defaultMessage: 'Edit board',
  },
});

const EditBoardBtn = () => {
  const dispatch = useDispatch();
  const board = useSelector(actions.readStateBoard);
  const layout = useSelector((state) => state?.layout);

  const activateEditMode = () => {
    // eslint-disable-next-line no-undef
    dispatch(rememberBoard(_.cloneDeep(board)));
    dispatch(actions.editMode(!layout.editMode));
    dispatch(actions.showLeftSidebar(false));
  };

  return (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.EDIT_BOARD} />}>
      <IconButton onClick={activateEditMode}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
};

export default EditBoardBtn;
